module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/center-img-e4c8324bbd0a8d3d04015265046e3991.png";